import { BasicCommand } from "~app/common/services/cqs/BasicCommand";
import { CommandType } from "~app/common/services/cqs/CommandType";

export class EditKundorderradCommand extends BasicCommand<EditKundorderradCommand> {
    primaryKey: import("../../../../../../common/services/cqs/IPrimaryKey").IPrimaryKey<EditKundorderradCommand>;
    kundorderradId: number;
    kvantitet: number;
    handelssortimentId: number;
    mottagningsplatsId: number;
    periodFrom: string;
    periodTom: string;
    manuellPaArbetsorder: boolean;
    egenskapskodX: boolean;
    // eslint-disable-next-line sonarjs/public-static-readonly
    static type = "EditKundorderradCommand";

    constructor(kundorderradId: number) {
        super("EditKundorderradCommand", "kundorderrad", CommandType.Replace);
        this.kundorderradId = kundorderradId;
    }
}
